import { Component, inject, signal } from '@angular/core';
import { BossAuthService } from '../../../shared/services/boss-auth.service';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'qwiko-onboarding-nav',
  imports: [TranslocoModule],
  templateUrl: './onboarding-nav.component.html',
  styleUrl: './onboarding-nav.component.scss',
})
export class OnboardingNavComponent {
  private bossAuthService = inject(BossAuthService);
  loading = signal<boolean>(false);

  async logout() {
    this.loading.set(true);
    await this.bossAuthService.signOut();
  }
}
